import axios from 'axios';
import * as actionTypes from './Actiontypes';

const BASE_URL = 'https://api.happiclips.com/api';

export const get_payment_plans = () => {
    return async (dispatch) => {
        dispatch({
            type: actionTypes.GET_PAYMENT_INIT
        })
        try {
            const authToken = localStorage.getItem('authToken');
            const res = await axios.get(`${BASE_URL}/get-all-plans`, {
                headers: {
                    Authorization: `Bearer ${authToken}`
                }
            });

            dispatch({
                type: actionTypes.GET_PAYMENT_SUCCESS,
                payload: res.data
            })

        }
        catch (error) {
            dispatch({
                type: actionTypes.GET_PAYMENT_FAIL,
                payload: error
            })
        }
    }
}